import { usePageId } from 'contexts/PageIdContext';
import React, { useEffect, useRef } from 'react';
interface Props {
	pageId: string;
}

export default function SurveyPageMarker({ pageId }: Props) {
	const ref = useRef<HTMLDivElement | null>(null);
	const { setActivePageId } = usePageId();

	useEffect(() => {
		if (!ref.current) return () => {};

		const observer = new IntersectionObserver(
			(entries) => {
				const entry = entries[0];
				if (entry.isIntersecting) {
					setActivePageId(pageId);
				}
			},
			{ threshold: 0.3 },
		);

		observer.observe(ref.current);

		return () => {
			observer.disconnect();
		};
	}, [pageId, setActivePageId]);

	return (
		<div
			ref={ref}
			aria-hidden
			style={{
				width: 1,
				height: 1,
				opacity: 0,
				pointerEvents: 'none',
			}}
		/>
	);
}
